import PropTypes from "prop-types";
import React, { useContext, useState, useEffect } from "react";
import Swiper from "react-id-swiper";
import { AuthContext } from "../../common/Auth"
import CategoryFourSingle from "../../components/category/CategoryFourSingle.js";
import SectionTitle from "../../components/section-title/SectionTitle";

const CategoryfourSlider = ({ spaceTopClass, spaceBottomClass }) => {
  const { categorySliderList, themeSettingsData, user } = useContext(AuthContext)
  const [data, setData] = useState({})
  const [arrTemp, setArrTemp] = useState([])
  const [toggeled, setToggeled] = useState(0)
  const [windowWidth, setWindowWidth] = useState([])
  useEffect(() => {
    const updateSize = () => {
      setWindowWidth(window?.outerWidth)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [window?.outerWidth])

  useEffect(() => {
    themeSettingsData.map((i) => {
      if (i.settingsName === 'categorySlider') {
        setData(i.values[0])
      }
    })
  }, [themeSettingsData])

  let pt = data.paddingTop ? data.paddingTop : 'pt-0'
  let pb = data.paddingBottom ? data.paddingBottom : 'pb-0'
  let mb = data.marginBottom ? data.marginBottom : 'mt-50'
  let mt = data.marginTop ? data.marginTop : 'mb-50'
  let mr = data.marginRight ? data.marginRight : 'mr-0'
  let ml = data.marginLeft ? data.marginLeft : 'ml-0'
  let pl = data.paddingLeft ? data.paddingLeft : 'pl-0'
  let pr = data.paddingRight ? data.paddingRight : 'pr-0'
  let wi = data.width ? data.width : "w-50";
  let fullSection = data.fullSection ? 'container-fluid' : 'container'
  let bgImage = data?.bgImage ? data?.bgImage : ''
  let bgColor = data?.bgColor ? data?.bgColor : "";
  let flipAnimation = data?.catFlipAnimation ? data?.catFlipAnimation : false
  let automaticSlider = data?.automaticSlider ? data?.automaticSlider : false
  let showPrevNextButton = data?.showPrevNextButton === false ? false : true

  let getAutoSlider = automaticSlider ? { delay: 7000,disableOnInteraction: false,} : false
  // swiper slider settings
  const settings = {
    justifyContent:'center',
    centerInsufficientSlides: true,
    loop: false,
    spaceBetween: 20,
    autoplay: getAutoSlider,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1536: {
        slidesPerView: 5,
        slidesPerGroup: data.groupSlider ? 5 : 1
      },
      1280: {
        slidesPerView: 4,
        slidesPerGroup: data.groupSlider ? 4 : 1
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: data.groupSlider ? 4 : 1
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: data.groupSlider ? 3 : 1
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: data.groupSlider ? 2 : 1
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: data.groupSlider ? 2 : 1
      },
      576: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      480: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    },
    shouldSwiperUpdate: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    renderPrevButton: () => (
      <>
         <button id="prev" className="antera-swiper-button swiper-button-prev ht-swiper-button-nav">
            <i className="pe-7s-angle-left" />
          </button>
      </>
    ),
    renderNextButton: () => (
      <>
       <button id="next" className="antera-swiper-button swiper-button-next ht-swiper-button-nav">
            <i className="pe-7s-angle-right" />
          </button>
      </>
    ),
  }

  function checkIsDisplay(single) {
    const userGroupSpecific = single?.userGroupSpecific;
    const userGroup = !!single?.userGroup && JSON.parse(single?.userGroup);
    const loggedInUser = user?.userGroups;
    let isDisplay = true
    if (userGroupSpecific == "true" && userGroup.length > 0) {
      isDisplay = userGroup.some((res) => {
        if (!!loggedInUser && loggedInUser.length > 0) {
          return loggedInUser.includes(res.id)
        } else {
          return false
        }
      });
    }
    return isDisplay
  }

  useEffect(() => {
    if (categorySliderList.length > 0) {
      categorySliderList.map((single, key) => {
        let isDisplay = checkIsDisplay(single);
        if (isDisplay) {
          let arr = arrTemp
          arr.push(isDisplay)
          setArrTemp(arr)
        }
      })
      setToggeled(toggeled + 1)
    }
  }, [categorySliderList])
  
  const renderCategorySlider = (categorySliderList) => {
    return categorySliderList.map((single, key) => {
      let isDisplay = checkIsDisplay(single);
      if (isDisplay) {
        return (
          <CategoryFourSingle
            data={single}
            key={key}
            sliderClass="swiper-slide"
            width={wi}
            flipAnimation={flipAnimation}
          />
        );
      }
      return <></>;
    })
  }

  return (
    <>
      <div className={`antera-categories-slider-section-container collections-area categorySlider categories-slider-container section-bgImage ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr}`}
        style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}>
        <SectionTitle
          titleText={data?.sectionTitle}
          spaceClass="mb-35 mt-20"
          borderClass="no-border"
        />
        <SectionTitle
          subTitleText={data?.subSectionTitle}
          spaceClass="mb-40"
          borderClass="no-border"
        />
        <div className={`antera-categories-slider-content-container ${fullSection}`}>
          {
            Object.keys(categorySliderList).length > 0 && 
            <>
              {windowWidth < 1010 || arrTemp.length >= 5 ? (
                <div className="slidWrap"
                style ={{
                  justifyContent: 'center',
                }}>
                  <Swiper {...settings}>
                    {renderCategorySlider(categorySliderList)}
                  </Swiper>
                </div>
              ) : (
                <div className="customSliderwrapper"
                style ={{
                  height:'auto !important',
                  justifyContent: arrTemp.length <= 1 ? 'center' : 'space-evenly',
                  gap: arrTemp.length <= 1 ? '0px' : '50px'
                }}
                >
                  {renderCategorySlider(categorySliderList)}
                </div>
              )}
            </>
          }
          {showPrevNextButton && <label className="antera-swiper-button custome-swiper-btn swiper-button-prev1" htmlFor="prev"><i className="pe-7s-angle-left"></i></label> }
          {showPrevNextButton && <label className="antera-swiper-button custome-swiper-btn swiper-button-next1" htmlFor="next"><i className="pe-7s-angle-right"></i></label> }
        </div>
      </div>
    </>
  )
}

CategoryfourSlider.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
}

export default CategoryfourSlider;
